module.exports = __webpack_public_path__ + "static/media/house12lg.bc4f1ecd.png";